import { render, staticRenderFns } from "./PublicKnowledgeElement.vue?vue&type=template&id=1da8349e&scoped=true&"
import script from "./PublicKnowledgeElement.vue?vue&type=script&lang=js&"
export * from "./PublicKnowledgeElement.vue?vue&type=script&lang=js&"
import style0 from "./PublicKnowledgeElement.vue?vue&type=style&index=0&id=1da8349e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da8349e",
  null
  
)

export default component.exports